exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton[data-v-ad10ac3c] {\n  background: #172b43;\n  color: #fff;\n  padding: 2px 4px;\n  border-radius: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-ad10ac3c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/components/excludeProjects.vue
// module id = 584
// module chunks = 0